import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ColorPicker.tsx
import { useState } from 'react';
const locale = {
    ru: { custom: 'Свой цвет', palette: 'Палитра' },
    en: { custom: 'Custom color', palette: 'Palette' },
    de: { custom: 'Eigene Farbe', palette: 'Palette' },
};
export function decimalToHex(decimal) {
    return '#' + Math.max(0, decimal).toString(16).padStart(6, '0').toUpperCase();
}
export function hexToDecimal(hex) {
    return parseInt(hex.replace('#', ''), 16);
}
export const ColorPicker = ({ value = '#8c4d24', onChange, palette = [], onPaletteChange, lang = 'en', header = "Color element" }) => {
    const t = locale[lang];
    const [current, setCurrent] = useState(value);
    const addToPalette = (hex) => {
        if (!onPaletteChange)
            return;
        if (palette.includes(hex))
            return;
        onPaletteChange([hex, ...palette].slice(0, 16));
    };
    const handleChange = (hex) => {
        setCurrent(hex);
        onChange(hex);
    };
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: 16 }, children: [_jsx("div", { style: { marginTop: 20, marginBottom: 8, fontSize: 11, fontWeight: 700, color: '#a0aec0', textTransform: 'uppercase', letterSpacing: 1 }, children: header }), _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 12 }, children: [_jsx("div", { style: {
                            width: 48, height: 48,
                            borderRadius: 10,
                            background: current,
                            border: '2px solid #e2e8f0',
                            flexShrink: 0,
                        } }), _jsxs("div", { style: { flex: 1 }, children: [_jsx("div", { style: { fontSize: 11, color: '#a0aec0', marginBottom: 4 }, children: t.custom }), _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 8 }, children: [_jsx("input", { type: "color", value: current, onChange: e => handleChange(e.target.value), onBlur: e => addToPalette(e.target.value), style: {
                                            width: 36, height: 32,
                                            border: 'none', borderRadius: 6,
                                            cursor: 'pointer', padding: 2,
                                        } }), _jsx("span", { style: {
                                            fontFamily: 'monospace', fontSize: 13,
                                            color: '#4a5568', background: '#f7fafc',
                                            padding: '4px 8px', borderRadius: 6,
                                            border: '1px solid #e2e8f0',
                                        }, children: current.toUpperCase() })] })] })] }), palette.length > 0 && (_jsxs("div", { children: [_jsx("div", { style: { fontSize: 11, color: '#a0aec0', marginBottom: 8 }, children: t.palette }), _jsx("div", { style: { display: 'flex', flexWrap: 'wrap', gap: 6 }, children: palette.map((hex, idx) => (_jsx("div", { onClick: () => handleChange(hex), title: hex, style: {
                                width: 32, height: 32,
                                borderRadius: 8,
                                background: hex,
                                cursor: 'pointer',
                                border: current === hex
                                    ? '2.5px solid #4488ff'
                                    : '2px solid #e2e8f0',
                                transition: 'transform 0.1s',
                                flexShrink: 0,
                            }, onMouseEnter: e => (e.currentTarget.style.transform = 'scale(1.15)'), onMouseLeave: e => (e.currentTarget.style.transform = 'scale(1)') }, hex + idx))) })] }))] }));
};
